'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveAttachmentsForMessage = undefined;

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _fileAttachmentIdsInMessage = require('conversations-schema/pubnub-message/operators/fileAttachmentIdsInMessage');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var _resolveAttachments = require('./resolveAttachments');

var resolveAttachmentsForMessage = exports.resolveAttachmentsForMessage = function resolveAttachmentsForMessage(message) {
  return function (dispatch, getState) {
    var fileIds = (0, _fileAttachmentIdsInMessage.fileAttachmentIdsInMessage)(message);

    if (fileIds.size) {
      var threadId = (0, _threadGetters.getThreadId)(message);
      var sessionId = (0, _getSessionId.getSessionId)(getState());

      dispatch((0, _resolveAttachments.resolveAttachments)({ fileIds: fileIds, sessionId: sessionId, threadId: threadId }));
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/resolved-attachments/actions/resolveAttachmentsForMessage.js
// module id = 424
// module chunks = 2 3